const reportTheme = {
  id: 305,
  name: "Bar",
  slug: "bar",
  title: null,
  description: null,
  clientID: 1,
  use_for_summary: false,
  allow_for_custom: false,
  country: "England",
};

const items = [
  {
    id: 685,
    reportThemeID: 305,
    text: null,
    chartType: "Bar",
    chartRef: "16698134215515125",
    chartDescription: "<p>Households with no car or van</p>",
    chartXLabel: null,
    chartYLabel: "Percent %",
    syncChartWithHTMLTableRef: null,
    inverseChartData: true,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 2,
    timeSeries: false,
    itemName: "Households with no car or van",
    itemSource: "UK Census",
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    indicators: [
      {
        id: 2779,
        indicatorHTMLTableRef: null,
        chartRef: "16698134215515125",
        indicatorCode: "ks404ew0002*dr",
        indicatorDate: "2011-01-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 866,
        indicatorName: "Households with no car  (E&W Census 2011)",
        source: "Census 2011",
        date: "2011-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2011",
      },
      {
        id: 2778,
        indicatorHTMLTableRef: null,
        chartRef: "16698134215515125",
        indicatorCode: "ks404ew0002*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 1138,
        indicatorName: "Households with no car (Census 2021)",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
    ],
  },
  {
    id: 1536,
    reportThemeID: 305,
    text: null,
    chartType: "Bar",
    chartRef: "16971197544639",
    chartDescription: "<p>IMD 2019 deprivation deciles</p>",
    chartXLabel: null,
    chartYLabel: "Percentage %",
    syncChartWithHTMLTableRef: null,
    inverseChartData: true,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 4,
    timeSeries: false,
    itemName: "Proportion of people in each deprivation decile",
    itemSource:
      "Ministry of Housing Communities and Local Government (MHCLG) 2019",
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    indicators: [
      {
        id: 4925,
        indicatorHTMLTableRef: null,
        chartRef: "16971197544639",
        indicatorCode: "imd19pop_dec1*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 564,
        indicatorName: "IMD 2019 Decile 1",
        source: "Communities and Local Government (CLG)",
        date: "2019-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2019",
      },
      {
        id: 4926,
        indicatorHTMLTableRef: null,
        chartRef: "16971197544639",
        indicatorCode: "imd19pop_dec2*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 1128,
        indicatorName: "IMD 2019 Decile 2",
        source: "Communities and Local Government (CLG)",
        date: "2019-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2019",
      },
      {
        id: 4927,
        indicatorHTMLTableRef: null,
        chartRef: "16971197544639",
        indicatorCode: "imd19pop_dec3*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 1157,
        indicatorName: "IMD 2019 Decile 3",
        source: "Communities and Local Government (CLG)",
        date: "2019-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2019",
      },
      {
        id: 4928,
        indicatorHTMLTableRef: null,
        chartRef: "16971197544639",
        indicatorCode: "imd19pop_dec4*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 1170,
        indicatorName: "IMD 2019 Decile 4",
        source: "Communities and Local Government (CLG)",
        date: "2019-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2019",
      },
      {
        id: 4929,
        indicatorHTMLTableRef: null,
        chartRef: "16971197544639",
        indicatorCode: "imd19pop_dec5*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 1179,
        indicatorName: "IMD 2019 Decile 5",
        source: "Communities and Local Government (CLG)",
        date: "2019-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2019",
      },
    ],
  },
  {
    id: 68,
    reportThemeID: 305,
    text: null,
    chartType: "Bar",
    chartRef: "16698082683325",
    chartDescription: "<p>Housing tenure breakdowns by type</p>",
    chartXLabel: null,
    chartYLabel: "Percent %",
    syncChartWithHTMLTableRef: null,
    inverseChartData: true,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 2,
    timeSeries: false,
    itemName: "Housing tenure",
    itemSource: "UK Census",
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    indicators: [
      {
        id: 295,
        indicatorHTMLTableRef: null,
        chartRef: "16698082683325",
        indicatorCode: "owneroccupied_2001*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 636,
        indicatorName: "Owner occupied housing (Census 2021)",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 296,
        indicatorHTMLTableRef: null,
        chartRef: "16698082683325",
        indicatorCode: "ks402ew0005*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 637,
        indicatorName: "Housing rented from council (Census 2021)",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 297,
        indicatorHTMLTableRef: null,
        chartRef: "16698082683325",
        indicatorCode: "ks402ew0006*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 638,
        indicatorName:
          "Housing rented from a Housing Association (Census 2021)",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 298,
        indicatorHTMLTableRef: null,
        chartRef: "16698082683325",
        indicatorCode: "ks402ew0007*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 639,
        indicatorName:
          "Private rented housing: Private landlord or letting agency (Census 2021)",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
    ],
  },
];

const comparatorAreaCodes = ["CSTM5160", "E10000012", "E10000011"];

const comparatorsList = [
  { area_code: "CSTM5160", area_name: "Comparator 1" },
  { area_code: "E10000012", area_name: "Comparator 2" },
  { area_code: "E10000011", area_name: "Comparator 3" },
];

// Indicator values for all bar chart examples
const indicatorValues = {
  // Example 1: Households with no car or van (2011 vs 2021)
  "CSTM5160.ks404ew0002*dr.2021-01-01.Households with no car (Census 2021).rate":
    "37.45%",
  "E10000012.ks404ew0002*dr.2021-01-01.Households with no car (Census 2021).rate":
    "15.88%",
  "E10000011.ks404ew0002*dr.2021-01-01.Households with no car (Census 2021).rate":
    "19.19%",

  "CSTM5160.ks404ew0002*dr.2011-01-01.Households with no car  (E&W Census 2011).rate":
    "38.19%",
  "E10000012.ks404ew0002*dr.2011-01-01.Households with no car  (E&W Census 2011).rate":
    "17.97%",
  "E10000011.ks404ew0002*dr.2011-01-01.Households with no car  (E&W Census 2011).rate":
    "21.85%",

  // Example 2: IMD 2019 deprivation deciles
  "CSTM5160.imd19pop_dec1*dr.2019-01-01.IMD 2019 Decile 1.rate": "8.2%",
  "E10000012.imd19pop_dec1*dr.2019-01-01.IMD 2019 Decile 1.rate": "10.0%",
  "E10000011.imd19pop_dec1*dr.2019-01-01.IMD 2019 Decile 1.rate": "9.5%",

  "CSTM5160.imd19pop_dec2*dr.2019-01-01.IMD 2019 Decile 2.rate": "9.1%",
  "E10000012.imd19pop_dec2*dr.2019-01-01.IMD 2019 Decile 2.rate": "10.0%",
  "E10000011.imd19pop_dec2*dr.2019-01-01.IMD 2019 Decile 2.rate": "10.0%",

  "CSTM5160.imd19pop_dec3*dr.2019-01-01.IMD 2019 Decile 3.rate": "9.8%",
  "E10000012.imd19pop_dec3*dr.2019-01-01.IMD 2019 Decile 3.rate": "10.0%",
  "E10000011.imd19pop_dec3*dr.2019-01-01.IMD 2019 Decile 3.rate": "10.0%",

  "CSTM5160.imd19pop_dec4*dr.2019-01-01.IMD 2019 Decile 4.rate": "10.2%",
  "E10000012.imd19pop_dec4*dr.2019-01-01.IMD 2019 Decile 4.rate": "10.0%",
  "E10000011.imd19pop_dec4*dr.2019-01-01.IMD 2019 Decile 4.rate": "10.0%",

  "CSTM5160.imd19pop_dec5*dr.2019-01-01.IMD 2019 Decile 5.rate": "10.5%",
  "E10000012.imd19pop_dec5*dr.2019-01-01.IMD 2019 Decile 5.rate": "10.0%",
  "E10000011.imd19pop_dec5*dr.2019-01-01.IMD 2019 Decile 5.rate": "10.0%",

  // Example 3: Housing tenure breakdowns
  "CSTM5160.owneroccupied_2001*dr.2021-01-01.Owner occupied housing (Census 2021).rate":
    "52.3%",
  "E10000012.owneroccupied_2001*dr.2021-01-01.Owner occupied housing (Census 2021).rate":
    "68.4%",
  "E10000011.owneroccupied_2001*dr.2021-01-01.Owner occupied housing (Census 2021).rate":
    "65.1%",

  "CSTM5160.ks402ew0005*dr.2021-01-01.Housing rented from council (Census 2021).rate":
    "8.7%",
  "E10000012.ks402ew0005*dr.2021-01-01.Housing rented from council (Census 2021).rate":
    "4.2%",
  "E10000011.ks402ew0005*dr.2021-01-01.Housing rented from council (Census 2021).rate":
    "5.8%",

  "CSTM5160.ks402ew0006*dr.2021-01-01.Housing rented from a Housing Association (Census 2021).rate":
    "12.4%",
  "E10000012.ks402ew0006*dr.2021-01-01.Housing rented from a Housing Association (Census 2021).rate":
    "8.9%",
  "E10000011.ks402ew0006*dr.2021-01-01.Housing rented from a Housing Association (Census 2021).rate":
    "10.2%",

  "CSTM5160.ks402ew0007*dr.2021-01-01.Private rented housing: Private landlord or letting agency (Census 2021).rate":
    "26.6%",
  "E10000012.ks402ew0007*dr.2021-01-01.Private rented housing: Private landlord or letting agency (Census 2021).rate":
    "18.5%",
  "E10000011.ks402ew0007*dr.2021-01-01.Private rented housing: Private landlord or letting agency (Census 2021).rate":
    "18.9%",
};

export default {
  reportTheme,
  items,
  indicatorValues,
  comparatorsList,
  comparatorAreaCodes,
};
